'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Jacuzzi = function (_React$Component) {
    _inherits(Jacuzzi, _React$Component);

    function Jacuzzi() {
        _classCallCheck(this, Jacuzzi);

        return _possibleConstructorReturn(this, (Jacuzzi.__proto__ || Object.getPrototypeOf(Jacuzzi)).apply(this, arguments));
    }

    _createClass(Jacuzzi, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M2.133 7.362C.923 7.362 0 6.438 0 5.23s.924-2.134 2.133-2.134 2.133.924 2.133 2.133S3.342 7.36 2.133 7.36zm0-2.844c-.427 0-.71.284-.71.71s.283.712.71.712.71-.284.71-.71-.354-.712-.71-.712zM9.598 8.784c-1.21 0-2.133-.924-2.133-2.133S8.39 4.52 9.598 4.52s2.133.924 2.133 2.133-.994 2.134-2.132 2.134zm0-2.844c-.427 0-.71.284-.71.71s.283.712.71.712.71-.284.71-.71-.354-.712-.71-.712zM4.763 13.974c-1.35 0-2.417-1.066-2.417-2.417S3.412 9.14 4.763 9.14s2.417 1.066 2.417 2.417-1.066 2.417-2.417 2.417zm0-3.413c-.57 0-.995.428-.995.996s.427.995.995.995.995-.426.995-.994-.427-.995-.995-.995zM14.716 13.405c-1.21 0-2.133-.924-2.133-2.133s.924-2.133 2.133-2.133 2.133.923 2.133 2.132-.925 2.133-2.134 2.133zm0-2.844c-.427 0-.71.285-.71.712s.283.71.71.71.71-.283.71-.71-.354-.71-.71-.71z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M23.46 14.543H21.4V6.51c0-1.85-1.494-3.414-3.414-3.414S14.573 4.59 14.573 6.51v.354c0 .427.355.71.71.71.428 0 .712-.283.712-.71V6.51c0-1.067.924-1.992 1.99-1.992s1.992.853 1.992 1.99v8.035H2.132c-1.21 0-2.133.995-2.133 2.133v1.777c0 3.84 2.558 7.11 6.042 8.105v1.564c0 .427.355.71.71.71s.712-.283.712-.71v-1.28c.355.142.71.142 1.066.142h8.53c.356 0 .712 0 1.067-.07v1.28c0 .426.355.71.71.71s.712-.284.712-.71v-1.565c3.483-1.067 6.042-4.338 6.042-8.177v-1.777c0-1.21-.924-2.133-2.133-2.133zm-11.16 1.42h4.05v4.55c0 .428-.354.712-.71.712h-2.702c-.355 0-.71-.284-.71-.71v-4.55zm-10.878.712c0-.427.355-.71.71-.71h8.746v1.776H1.422v-1.065zm15.64 8.887h-8.53c-3.697 0-6.683-2.773-7.038-6.398h9.456v1.35c0 1.21.924 2.134 2.133 2.134h2.56c1.208 0 2.132-.924 2.132-2.133v-1.35h6.398c-.355 3.625-3.413 6.397-7.11 6.397zm7.11-7.82h-6.398v-1.777h5.688c.355 0 .71.284.71.71v1.067z' })
            );
        }
    }]);

    return Jacuzzi;
}(_react2.default.Component);

Jacuzzi.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Jacuzzi;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/jacuzzi.js
// module id = 1107
// module chunks = 0